import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
// import { pathTypes } from '@utils/sectionEnums';

export function updateWelcomeMessageApiCall({
  id,
  isPathDesign,
  welcomeMessage,
  welcomeMessageDelay,
  welcomeMessageFrequency,

  sectionIsBackground,
  sectionBorderColor,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,
  sectionBackgroundType,
}) {
  console.log('API_CALL_sectionBackgroundType:', sectionBackgroundType);
  return httpClient.put(getSectionHeadingPath('welcomemessage', isPathDesign), {
    id,
    message: welcomeMessage,
    delay: welcomeMessageDelay,
    frequency: welcomeMessageFrequency,
    sectionBorderColor,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,
    isSectionBackground: sectionIsBackground,
  });
}
